import { defineStore } from 'pinia'

const useInfotextStore = defineStore('InfotextStore', {
    state : () => {
      return {
        infotexts : {},
      }
    },
    getters : {
    },
    actions : {
        content(infotext, element = 'content'){
          try {
            return this.infotexts[infotext][element]
          } catch (ex) {
            return ''
          }
        }
    },
    
  })
  
  export { useInfotextStore }
